import { useState } from "react";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { ListarEquipeDeVendasController } from "../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { ListarUsuariosPorEquipeVendasController } from "../../../Controllers/Vendas/Usuario/UsuarioController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IClienteCompleto } from "../../../Interfaces/Geral/Cliente/IClienteSimples";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../Components/Form";
import { AlterarUsuarioResponsavelVendasController } from "../../../Controllers/Vendas/Caso/CasoController";
import { Dispatch, SetStateAction } from "react";

interface ITransferirCorretorResponsavelProps {
    idCorretorResponsavel: number;
    updateList?: any;
    ID_CASO?: number;
    setShow: Dispatch<SetStateAction<boolean>>;
    ID_CONTA?: number;
    filter?: any;
}

export default function TransferirCorretorResponsavel(
    props: ITransferirCorretorResponsavelProps
) {
    const [equipes, setEquipes] = useState("");

    const {
        loading: ListarUsuariosPorEquipeVendasLoading,
        value: usuariosPorEquipeVendas,
    } = useAsyncEffect(async () => {
        if (equipes)
            return ListarUsuariosPorEquipeVendasController(Number(equipes));
    }, [equipes]);

    const {
        execute: AlterarUsuarioResponsavel,
        loading: AlterarUsuarioResponsavelLoading,
    } = useAsyncCallback(AlterarUsuarioResponsavelVendasController);

    function handleTransferirCorretor(formData: IClienteCompleto) {
        AlterarUsuarioResponsavel({
            ID_CASO: props.ID_CASO ? props.ID_CASO : undefined,
            ID_CONTA: props.ID_CONTA ? props.ID_CONTA : undefined,
            ID_USUARIO: formData.ID_USUARIO_PROPRIETARIO ?? 0,
        }).then(() => {
            props.setShow(false);

            if (props.updateList && props.filter) {
                props.updateList(1, props.filter);
            } else if (props.updateList) {
                props.updateList();
            }
        });
    }

    return (
        <div>
            <UnForm handleSubmit={handleTransferirCorretor}>
                <div className="form-group">
                    <label htmlFor="ID_EQUIPE_VENDAS">Equipe de Vendas</label>
                    <UnForm.LazySelect
                        name="ID_EQUIPE_VENDAS"
                        className="form-control mb-2"
                        controller={ListarEquipeDeVendasController}
                        getDS={(equipe) => equipe.DS_EQUIPE_VENDAS}
                        getKeyValue={(equipe) => equipe.ID_EQUIPE_VENDAS}
                        registerOptions={{
                            required: "Selecione uma equipe",
                        }}
                        onChange={(e) => {
                            setEquipes(e.target.value);
                        }}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                    {ListarUsuariosPorEquipeVendasLoading ? (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner size="sm" color="primary" />
                        </div>
                    ) : (
                        <>
                            {usuariosPorEquipeVendas &&
                                usuariosPorEquipeVendas?.length > 0 && (
                                    <>
                                        {" "}
                                        <label htmlFor="ID_USUARIO_PROPRIETARIO">
                                            Corretor
                                        </label>
                                        <UnForm.Select
                                            name="ID_USUARIO_PROPRIETARIO"
                                            className="form-control"
                                            registerOptions={{
                                                required:
                                                    "Selecione um corretor",
                                            }}
                                        >
                                            <option></option>
                                            {usuariosPorEquipeVendas.map(
                                                (usuario) => (
                                                    <option
                                                        key={usuario.ID_USUARIO}
                                                        value={
                                                            usuario.ID_USUARIO
                                                        }
                                                    >
                                                        {usuario.DS_NOME}
                                                    </option>
                                                )
                                            )}
                                        </UnForm.Select>
                                    </>
                                )}
                        </>
                    )}

                    {usuariosPorEquipeVendas?.length === 0 && (
                        <div className="text-info text-center mt-2">
                            Não existe corretor para essa equipe de vendas.
                        </div>
                    )}
                </div>

                <button
                    className="btn btn-success col-12"
                    type="submit"
                    disabled={
                        AlterarUsuarioResponsavelLoading ||
                        usuariosPorEquipeVendas?.length === 0
                    }
                >
                    {AlterarUsuarioResponsavelLoading ? (
                        <Spinner color="primary" size="sm" />
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faExchangeAlt} /> Transferir
                        </>
                    )}
                </button>
            </UnForm>
        </div>
    );
}
